import request from "../utils/request";
const { swSewagePath, swPatrol, ocpSaasPath } = window.globalConfig;
export default class InspectionApi {
  /**
   * 新模块查询巡检模版 分页
   * @param params
   * @returns {*|Promise<*>}
   */
  static query = (params) => {
    return request.post(`/${swPatrol}/api/template/listByPage`, params);
  };
  /**
   * 查询巡检模版列表
   * @param params
   * @returns {*|Promise<*>}
   */
  static insTemplateList = (params) => {
    return request.post(`/${swPatrol}/api/template/list`, params);
  };
  /**
   * 创建巡检模版
   * @param params
   * @returns {*|Promise<*>}
   */
  static add = (params) => {
    return request.post(`/${swPatrol}/api/template/add`, params);
  };
  /**
   * 状态启用
   * @param params
   * @returns {*|Promise<*>}
   */
  static enable = (params) => {
    return request.post(
      `/${swPatrol}/api/template/enable?id=${params.id}&processId=${params.processId}`
    );
  };
  /**
   * 状态禁用
   * @param params
   * @returns {*|Promise<*>}
   */
  static disenable = (params) => {
    return request.post(
      `/${swPatrol}/api/template/disable?id=${params.id}&processId=${params.processId}`
    );
  };
  /**
   * 查询模版详情
   * @param params
   * @returns {*|Promise<*>}
   */
  static getInfo = (params) => {
    return request.post(`/${swPatrol}/api/template/getInfo`, params);
  };
  /**
   * 修改巡检模版
   * @param params
   * @returns {*|Promise<*>}
   */
  static update = (params, processId) => {
    return request.post(
      `/${swPatrol}/api/template/updateInfo?processId=${processId}`,
      params
    );
  };
  // POST /api/template / batchImportTemplate
  /**
   * 导入模版
   * @param params
   * @returns {*|Promise<*>}
   */
  static batchImportTemplate = (params, config) => {
    return request.post(
      `/${swPatrol}/api/template/batchImport`,
      params,
      config
    );
  };
  /*********************** 巡检标准 b **************************/
  /**
   * 巡检标准新增
   * @param params
   * @returns {*|Promise<*>}
   */
  static standAdd = (params) => {
    return request.post(`/${swPatrol}/api/standard/add`, params);
  };
  /**
   * 巡检标准状态启用
   * @param params
   * @returns {*|Promise<*>}
   */
  static standEnable = (params) => {
    return request.post(
      `/${swPatrol}/api/standard/enable?id=${params.id}&processId=${params.processId}`
    );
  };
  /**
   * 巡检标准新增调用流程
   * @param params
   * @returns {*|Promise<*>}
   */
  static standardStartProcess = (params) => {
    return request.post(
      `/${swPatrol}/api/standard/startProcess?id=${params.id}&processId=${params.processId}`
    );
  };
  /**
   * 巡检标准状态禁用
   * @param params
   * @returns {*|Promise<*>}
   */
  static standDisenable = (params) => {
    return request.post(
      `/${swPatrol}/api/standard/disable?id=${params.id}&processId=${params.processId}`
    );
  };
  /**
   * 巡检标准获取详情
   * @param params
   * @returns {*|Promise<*>}
   */
  static standGetInfo = (id) => {
    return request.post(`/${swPatrol}/api/standard/getInfo`, { id });
  };
  /**
   * 巡检标准-查询列表
   * @param params
   * @returns {*|Promise<*>}
   */
  static standQuery = (params) => {
    return request.post(`/${swPatrol}/api/standard/listByPage`, params);
  };
  /**
   * 巡检标准修改信息
   * @param params
   * @returns {*|Promise<*>}
   */
  static standUpdate = (params, processId) => {
    return request.post(
      `/${swPatrol}/api/standard/updateInfo?processId=${processId}`,
      params
    );
  };
  /**
   * 巡检标准删除
   * @param params
   * @returns {*|Promise<*>}
   */
  static standDelete = (params) => {
    return request.post(
      `/${swPatrol}/api/standard/delete?id=${params.id}&processId=${params.processId}`
    );
  };
  /**
   * 设备id
   */
  static deviceRelevancyTree = (params, config) => {
    return request.post(
      `/${swSewagePath}/api/deviceRelevancy/getDeviceRelevancyTree`,
      params,
      config
    );
  };

  /**
   * 缺陷等级
   */
  static getDefectLevelByStationId = (params) => {
    return request.post(
      `/${swPatrol}/api/defectLevel/getDefectLevelByStationId?stationId=${params.stationId}`,
      params
    );
  };

  // 缺陷等级详情
  static defectLevelGetInfo = (params) => {
    return request.post(`/${swPatrol}/api/defectLevel/getInfo`, params);
  };

  /*********************** 巡检计划 e **************************/
  /**
   * 巡检计划-查询列表
   * @param params
   * @returns {*|Promise<*>}
   */
  static planList = (params) => {
    return request.post(`/${swPatrol}/api/plan/listByPage`, params);
  };
  /**
   * 巡检计划状态启用
   * @param params
   * @returns {*|Promise<*>}
   */
  static planEnable = (params) => {
    return request.post(`/${swPatrol}/api/plan/enable?id=${params.id}`);
  };
  /**
   * 巡检计划状态禁用
   * @param params
   * @returns {*|Promise<*>}
   */
  static planDisenable = (params) => {
    return request.post(`/${swPatrol}/api/plan/disenable?id=${params.id}`);
  };
  /**
   * 巡检计划状态新增
   * @param params
   * @returns {*|Promise<*>}
   */
  static planAdd = (params) => {
    return request.post(`/${swPatrol}/api/plan/add`, params);
  };
  /**
   * 巡检计划状态编辑
   * @param params
   * @returns {*|Promise<*>}
   */
  static planEdit = (params) => {
    return request.post(`/${swPatrol}/api/plan/updateInfo`, params);
  };

  /**
   * 查询模版详情
   * @param params
   * @returns {*|Promise<*>}
   */
  static planInfo = (id) => {
    return request.appid(`/${swPatrol}/api/plan/getInfo?id=${id}`);
  };

  /*********************** 巡检项 b **************************/

  static getPatrolItems = (id, type) => {
    return request.appid(
      `//${swPatrol}/api/apiitem/getPatrolItems?stationId=${id}&type=${type}`
    );
  };
  static selectPatrolItemByStation = (id) => {
    return request.appid(
      `/${swPatrol}/api/apiitem/selectPatrolItemByStation?stationId=${id}`
    );
  };
  static selectPatrolItemsByParams = (params) => {
    return request.post(
      `//${swPatrol}/api/apiitem/selectPatrolItemsByParams`,
      params
    );
  };
  /*********************** 巡检项 e **************************/

  /*********************** 巡检任务 b **************************/

  // 巡检任务列表
  static taskQuery = (params) => {
    return request.post(`/${swPatrol}/api/patrolTaskGroup/listByPage`, params);
  };
  // 巡检任务添加
  static taskAdd = (params) => {
    return request.post(`/${swPatrol}/api/patrolTaskGroup/add`, params);
  };
  // 巡检任务详情
  static getPatrolTaskInfo = (params) => {
    return request.post(`/${swPatrol}/api/patrolTaskGroup/getInfo`, params);
  };
  // 巡检任务状态
  static getTaskHandleStatus = (params) => {
    return request.post(
      `/${swPatrol}/api/patrolTaskGroup/getTaskHandleStatus`,
      params
    );
  };

  /*********************** 巡检任务 简陋 **************************/
  // 捡漏列表
  static taskLeakList = (params) => {
    return request.post(`/${swPatrol}/api/taskLeak/listByPage`, params);
  };
  static taskLeakAdd = (params) => {
    return request.post(`/${swPatrol}/api/taskLeak/add`, params);
  };

  /*********************** 缺陷单 **************************/
  // 列表分页
  static defectQuery = (params) => {
    return request.post(`/${swPatrol}/api/defectOrder/listByPage`, params);
  };
  // 列表
  static defectList = (params) => {
    return request.post(`/${swPatrol}/api/defectOrder/list`, params);
  };
  static defectAdd = (params) => {
    return request.post(`/${swPatrol}/api/defectOrder/add`, params);
  };
  // 关闭缺陷
  static closeDefectOrder = (params) => {
    return request.post(`/${swPatrol}/api/defectOrder/close`, params);
  };
  // 缺陷转工单
  static turnToWorkOrder = (params) => {
    return request.post(`/${swPatrol}/api/apidefect/turnToWorkOrder`, params);
  };
  // 接受
  static defectAccept = (params) => {
    return request.post(`/${swPatrol}/api/defect/accept`, params);
  };
  // 验收
  static checkAccept = (params) => {
    return request.post(`/${swPatrol}/api/defectOrder/checkAccept`, params);
  };
  // 详情
  static defectInfo = (params) => {
    return request.post(`/${swPatrol}/api/defectOrder/getInfo`, params);
  };
  // 关联缺陷单
  static defectRelation = (params) => {
    return request.post(`/${swPatrol}/api/defectOrder/relation`, params);
  };
  static defectOrderSupplement = (params) => {
    return request.post(`/${swPatrol}/api/defectOrder/supplement`, params);
  };
  // 调度中心
  static defectOrderCenter = (params) => {
    return request.post(
      `/${swPatrol}/api/defectOrderCenter/listByPage`,
      params
    );
  };
  // 调度中心指派
  static defectOrderCenterSpecify = (params) => {
    return request.post(`/${swPatrol}/api/defectOrderCenter/specify`, params);
  };
  static defectOrderCenterInfo = (params) => {
    return request.post(`/${swPatrol}/api/defectOrderCenter/getInfo`, params);
  };
  /*********************** 缺陷 等级 **************************/
  //缺陷 等级 列表分页
  static defectLevel = (params) => {
    return request.post(`/${swPatrol}/api/defectLevel/listByPage`, params);
  };
  //缺陷 等级 列表
  static defectLevelLs = (params) => {
    return request.post(`/${swPatrol}/api/defectLevel/list`, params);
  };
  //缺陷 等级 添加
  static defectLevelAdd = (params) => {
    return request.post(`/${swPatrol}/api/defectLevel/add`, params);
  };
  //缺陷 等级 删除
  static defectLevelDel = (params) => {
    return request.post(
      `/${swPatrol}/api/defectLevel/remove?id=${params.id}`,
      params
    );
  };
  //缺陷 等级 更新
  static defectLevelUpdate = (params) => {
    return request.post(`/${swPatrol}/api/defectLevel/update`, params);
  };
  /*********************** 指令单 b **************************/
  // 指令单
  static instructOrder = (params) => {
    return request.post(`/${swPatrol}/api/instructOrder/listByPage`, params);
  };
  //添加指令单
  static instructOrderAdd = (params) => {
    return request.post(`/${swPatrol}/api/instructOrder/add`, params);
  };
  // 缺陷单生成指令单
  static defectOrderInstructOrderAdd = (params) => {
    return request.post(`/${swPatrol}/api/defectOrder/instructOrderAdd`, params);
  };
  //完成指令单  /api/instructOrder/listByPage
  static orderComplate = (id) => {
    return request.post(`/${swPatrol}/api/instructOrder/complate?id=${id}`);
  };
  //完成指令单  /api/instructOrder/delivery
  static orderDelivery = (id) => {
    return request.post(`/${swPatrol}/api/instructOrder/delivery?id=${id}`);
  };
  // 关闭指令单
  static closeInstructOrder = (params) => {
    return request.post(`/${swPatrol}/api/instructOrder/close`, params);
  };
  // 提交指令单
  static submiteInstructOrder = (params) => {
    return request.post(`/${swPatrol}/api/instructOrder/submit`, params);
  };
  // 转单
  static transferInstructOrder = (params) => {
    return request.post(`/${swPatrol}/api/instructOrder/transfer`, params);
  };
  // 指令单详情
  static instructOrderInfo = (params) => {
    return request.post(`/${swPatrol}/api/instructOrder/getInfo`, params);
  };
  /**************************工单 */
  // 工单分页
  static workOrder = (params) => {
    return request.post(`/${swPatrol}/api/workOrder/listByPage`, params);
  };
  // 工单列表
  static workList = (params) => {
    return request.post(`/${swPatrol}/api/workOrder/list`, params);
  };
  // 工单新增
  static workOrderAdd = (params) => {
    return request.post(`/${swPatrol}/api/workOrder/add`, params);
  };

  // 通过缺陷单生成工单
  static defectOrderWorkOrderAdd = (params) => {
    return request.post(`/${swPatrol}/api/defectOrder/workOrderAdd`, params);
  };

  // 工单详情
  static workOrderGetInfo = (params) => {
    return request.post(`/${swPatrol}/api/workOrder/getInfo`, params);
  };
  // 关闭工单
  static workOrderClose = (params) => {
    return request.post(`/${swPatrol}/api/workOrder/close`, params);
  };
  // 提交工单结果
  static workOrderSubmit = (params) => {
    return request.post(`/${swPatrol}/api/workOrder/submit`, params);
  };
  // 工单转单
  static workOrderTransfer = (params) => {
    return request.post(`/${swPatrol}/api/workOrder/transfer`, params);
  };
  // 工单特种作业票
  static workOrderTicketAdd = (params) => {
    return request.post(`/${swPatrol}/api/workOrderTicket/add`, params);
  };
  // 新增工单外委
  static workOrderAssignAdd = (params) => {
    return request.post(`/${swPatrol}/api/workOrderAssign/add`, params);
  };
  // 外委工单启用
  static workOrderAssignEnable = (params) => {
    return request.post(
      `/${swPatrol}/api/workOrderAssign/startProcess?processId=${params.processId}&id=${params.id}`
    );
  };
  // 指派
  static workOrderSpecify = (params) => {
    return request.post(`/${swPatrol}/api/workOrder/specify`, params);
  };

  /*************************保养 */
  // 保养模板-列表
  static upkeepTemplate = (params) => {
    return request.post(`/${swPatrol}/api/upkeepTemplate/query`, params);
  };
  // 保养模板-列表-根据条件查询
  static upkeepFlagTemplate = (params) => {
    return request.post(
      `/${swPatrol}/api/upkeepTemplate/queryTemplate`,
      params
    );
  };
  // 保养模板-新增
  static upkeepTemplateAdd = (params) => {
    return request.post(
      `/${swPatrol}/api/upkeepTemplate/addUpkeepTemplate`,
      params
    );
  };
  // 保养模板-禁用
  static upkeepTemplateDisenable = (params) => {
    return request.post(
      `/${swPatrol}/api/upkeepTemplate/disable?id=${params.id}&processId=${params.processId}`
    );
  };
  // 保养模板-启用
  static upkeepTemplateEnable = (params) => {
    return request.post(
      `/${swPatrol}/api/upkeepTemplate/enable?id=${params.id}&processId=${params.processId}`
    );
  };
  // 保养模板-详情
  static upkeepTemplateGetInfo = (id) => {
    return request.appid(
      `/${swPatrol}/api/upkeepTemplate/getInfo?templateId=${id}`
    );
  };
  // 保养模板-修改
  static upkeepTemplateUpdateInfo = (params, processId) => {
    return request.post(
      `/${swPatrol}/api/upkeepTemplate/updateInfo?processId=${processId}`,
      params
    );
  };
  // 保养模板-导入
  static upkeepTemplateBatchImport = (params) => {
    return request.post(`/${swPatrol}/api/upkeepTemplate/batchImport`, params);
  };
  // 保养标准
  static upkeepStandard = (params) => {
    return request.post(`/${swPatrol}/api/upkeepStandard/query`, params);
  };
  static upkeepStandardAdd = (params) => {
    return request.post(`/${swPatrol}/api/upkeepStandard/add`, params);
  };
  // 保养标准-禁用
  static upkeepStandardDisenable = (params) => {
    return request.post(
      `/${swPatrol}/api/upkeepStandard/disable?id=${params.id}&processId=${params.processId}`
    );
  };
  // 保养标准-启用
  static upkeepStandardEnable = (params) => {
    return request.post(
      `/${swPatrol}/api/upkeepStandard/enable?id=${params.id}&processId=${params.processId}`
    );
  };
  // 保养标准-详情
  static upkeepStandardGetInfo = (params) => {
    return request.post(`/${swPatrol}/api/upkeepStandard/getInfo`, params);
  };
  // 保养标准-修改
  static upkeepStandardUpdateInfo = (params, processId) => {
    return request.post(
      `/${swPatrol}/api/upkeepStandard/updateInfo?processId=${processId}`,
      params
    );
  };
  // 保养标准-批量导入
  static upkeepStandardBatchImport = (params) => {
    return request.post(`/${swPatrol}/api/upkeepStandard/batchImport`, params);
  };

  // 保养计划
  static upkeepPlan = (params) => {
    return request.post(`/${swPatrol}/api/upkeepPlan/listByPage`, params);
  };
  // 保养计划新增
  static upkeepPlanAdd = (params) => {
    return request.post(`/${swPatrol}/api/upkeepPlan/add`, params);
  };
  // 保养任务
  static upkeepTask = (params) => {
    return request.post(`/${swPatrol}/api/upkeepTask/listByPage`, params);
  };
  // 保养任务列表
  static upkeepQuery = (params) => {
    return request.post(
      `/${swPatrol}/api/upkeepTask/queryByRoleAndStation`,
      params
    );
  };
  // 保养任务列表
  static upkeepQuery1 = (params) => {
    return request.post(`/${swPatrol}/api/upkeepTask/query`, params);
  };
  // 保养任务新增
  static upkeepTaskAdd = (params) => {
    return request.post(`/${swPatrol}/api/upkeepTask/add`, params);
  };
  // 保养任务-完成
  static upkeepTaskFinish = (params) => {
    return request.post(`/${swPatrol}/api/upkeepTask/finish`, params);
  };
  // 保养任务-详情
  static upkeepTaskGetDetail = (params) => {
    return request.post(`/${swPatrol}/api/upkeepTask/getDetail`, params);
  };

  // 获取厂站所有角色的巡检路线图
  static lineList = (params) => {
    return request.post(
      `/${swPatrol}/patrolStandardRoute/getPatrolStandardRoute`,
      params
    );
  };
  // 新增线路
  static lineAdd = (params) => {
    return request.post(`/${swPatrol}/api/deviceRoute/add`, params);
  };
  // 线路修改
  static lineUpdate = (params) => {
    return request.post(`/${swPatrol}/patrolStandardRoute/save`, params);
  };

  // 待办事项列表
  static todoList = (params) => {
    return request.post(`/${swPatrol}/api/agentMessage/query`, params);
  };

  // 待办事项详情
  static todoDetail = (params) => {
    return request.post(`/${swPatrol}/api/agentMessage/getDetail`, params);
  };

  // 用户提交审核
  static completeTask = (params) => {
    return request.post(`/sw-flowable/api/0/task/completeTask`, params);
  };

  // 漏检列表
  static patrolTaskLeakLs = (params) => {
    return request.post(
      `/${swPatrol}/api/patrolTaskGroupLeak/listByPage`,
      params
    );
  };

  // 提交漏检说明
  static submitLeakDesc = (params) => {
    return request.post(
      `/${swPatrol}/api/patrolTaskGroupLeak/submitLeakDesc`,
      params
    );
  };

  // 巡检模板项
  static getTemplateItems = (params) => {
    return request.post(
      `/${swPatrol}/api/templateItem/getTemplateItems`,
      params
    );
  };

  // 查询多个巡检模板项
  static getTemplateItemsByIds = (params) => {
    return request.post(
      `/${swPatrol}/api/templateItem/getTemplateItemsByIds`,
      params
    );
  };

  // 工单-特种作业票执行结果
  static workOrderTicketSubmit = (params) => {
    return request.post(`/${swPatrol}/api/workOrderTicket/submit`, params);
  };

  // 工单延期记录
  static workOrderDelayList = (params) => {
    return request.post(`/${swPatrol}/api/workOrderDelay/list`, params);
  };

  // 消息列表分页
  static messageListPage = (params) => {
    return request.post(`/ocp-saas/api/0/message/listByPage`, params);
  };

  // 更新消息阅读状态
  static messageRead = (params) => {
    return request.appid(`/ocp-saas/api/0/message/read?id=${params.id}`);
  };

  // 工单催单
  static workOrderUrge = (params) => {
    return request.post(`/${swPatrol}/api/workOrder/urge`, params);
  };

  // 下载巡检模板
  static downloadTemplate = () => {
    return request.appid(`/${swPatrol}/api/template/downloadTemplate`, {
      responseType: "blob",
    });
  };

  // 下载巡检标准模板
  static standardDownloadTemplate = (params) => {
    return request.appid(
      `/${swPatrol}/api/standard/downloadTemplate?templateType=${params.templateType}`,
      {
        responseType: "blob",
      }
    );
  };

  // 下载保养模板
  static downloadUpkeepTemplate = () => {
    return request.appid(`/${swPatrol}/api/upkeepTemplate/downloadTemplate`, {
      responseType: "blob",
    });
  };

  // 下载保养标准模板
  static downloadUpkeepStandardTmp = () => {
    return request.appid(`/${swPatrol}/api/upkeepStandard/downloadTemplate`, {
      responseType: "blob",
    });
  };

  // 巡检班主
  static getPatrolDeptsApi = (params) => {
    return request.post(`/${swPatrol}/api/standard/getPatrolDepts`, params);
  };

  // 根据部门ids获取用户
  static getUsersByDeptIds = (params) => {
    return request.post(`/${ocpSaasPath}/api/0/user/getUsersByDeptIds`, params);
  };

  // 巡检任务派单
  static assignOrder = (params) => {
    return request.post(`/${swPatrol}/api/patrolTaskGroup/assignOrder`, params);
  };

  /**
   * 根据设备ID查询巡检任务组
   */
  static getPatrolMapTaskGroup = (params) => {
    return request.post(
      `/${swPatrol}/api/patrolTaskGroup/getPatrolMapTaskGroup`,
      params
    );
  };

  /**
   * 根据设备id和任务id查询任务项
   */
  static getPatrolMapTaskItems = (params) => {
    return request.post(
      `/${swPatrol}/api/patrolTaskGroup/getPatrolMapTaskItems`,
      params
    );
  };

  /**
   * 巡检报告
   */
  static getPatrolReport = (params) => {
    return request.post(
      `/${swPatrol}/api/patrolTaskGroup/getPatrolReport`,
      params
    );
  };

  /**
   * 巡检任务统计
   */
  static getPatrolTaskGroupStatistics = (params) => {
    return request.post(
      `/${swPatrol}/api/patrolTaskGroup/getPatrolTaskGroupStatistics`,
      params
    );
  };

  /**
   * 巡检任务项统计
   */
  static getPatrolTaskItemStatistics = (params) => {
    return request.post(
      `/${swPatrol}/api/patrolTaskItem/getPatrolTaskItemStatistics`,
      params
    );
  };

  /**
   * 缺陷单统计
   */
  static getDefectOrderStatistics = (params) => {
    return request.post(
      `/${swPatrol}/api/defectOrder/getDefectOrderStatistics`,
      params
    );
  };

  /**
   * 工单统计
   */
  static getPatrolWorkOrderStatistics = (params) => {
    return request.post(
      `/${swPatrol}/api/workOrder/getPatrolWorkOrderStatistics`,
      params
    );
  };

  /**
   * 巡检班组
   */
  static patrolDeptGetPatrolDepts = (params) => {
    return request.post(
      `/${swPatrol}/api/patrolDept/getPatrolDepts`,
      params
    );
  };

  // 导出巡检标准模板
  static exportPatrolStandardItemTemplate = (params) => {
    return request.post(
      `/${swPatrol}/api/standard/exportPatrolStandardItemTemplate`,
      params,
      {
        responseType: "blob",
      }
    );
  };

  /**
   * 导入巡检标准
   */
  static importPatrolStandardItemTemplate = (params) => {
    return request.post(
      `/${swPatrol}/api/standard/importPatrolStandardItemTemplate`,
      params
    );
  };

  /**
   * 删除漏检
   */
  static deleteLeakTaskGroup = (params) => {
    return request.post(
      `/${swPatrol}/api/patrolTaskGroup/deleteLeakTaskGroup`,
      params
    );
  };

}
